import {FC} from 'react'

type Props = {
  two_steps?: boolean
}

const BookingreportTwoStepsCell: FC<Props> = ({two_steps}) => (
  <> {two_steps && <div className='badge badge-success fs-4 fw-bolder'>Booked</div>}</>
)

export {BookingreportTwoStepsCell}
